module.exports = __webpack_public_path__ + "static/media/arrowup.22b4dc20.svg";